module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "Srig-group",
    on: {
      "click": _vm.shopping_hide_1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "Srig"
  }, [_c('div', {
    staticClass: "shopping-car-page"
  }, [_c('div', {
    staticStyle: {
      "text-align": "left"
    },
    on: {
      "click": _vm.shopping_hide_1
    }
  }, [_c('img', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "src": require("./assets/store/back_android.png"),
      "width": "18"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "shopping_span"
  }, [_vm._v(_vm._s(_vm.$t('shopping_card_pack_up')))])]), _vm._v(" "), _c('h1', {
    staticClass: "shopping-title"
  }, [_vm._v(_vm._s(_vm.$t('shopping_card_title')))]), _vm._v(" "), (_vm.goods.length > 0) ? _c('Row', {
    staticStyle: {
      "width": "90%",
      "margin": "5% auto"
    }
  }, [_c('i-col', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('Checkbox', {
    staticClass: "checkALL",
    staticStyle: {
      "font-size": "14px",
      "color": "#5E6D82"
    },
    on: {
      "on-change": _vm.selectAll
    },
    model: {
      value: (_vm.checkALL),
      callback: function($$v) {
        _vm.checkALL = $$v
      },
      expression: "checkALL"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('shopping_card_selected')) + "\n                    ")])], 1), _vm._v(" "), _c('i-col', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.goToOrderList
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/store/full.png"),
      "width": "20"
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('Row', {
    staticClass: "shopping-car-main-page",
    attrs: {
      "width": "100%"
    }
  }, _vm._l((_vm.goods), function(item, index, key) {
    return _c('i-col', {
      key: index,
      staticStyle: {
        "background": "white",
        "margin-top": "15px"
      },
      attrs: {
        "span": 24
      }
    }, [_c('div', {
      staticClass: "shopping-product",
      staticStyle: {
        "margin": "5% auto",
        "width": "90%",
        "display": "flex"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "5%"
      }
    }, [_c('Checkbox', {
      staticStyle: {
        "font-size": "14px",
        "color": "#5E6D82"
      },
      model: {
        value: (item.if_checked),
        callback: function($$v) {
          _vm.$set(item, "if_checked", $$v)
        },
        expression: "item.if_checked"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "30%",
        "margin": "10px"
      }
    }, [_c('img', {
      attrs: {
        "src": item.goods_img,
        "width": "100%"
      },
      on: {
        "click": function($event) {
          _vm.detail(item)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "40%",
        "padding": "0 10px",
        "position": "relative",
        "max-height": "100px"
      }
    }, [_c('p', {
      staticStyle: {
        "font-size": "16px",
        "color": "#5E6D82",
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(item.goods_name))]), _vm._v(" "), _c('div', {
      staticClass: "shopping-number",
      staticStyle: {
        "margin-top": "10%"
      }
    }, [_c('button', {
      staticStyle: {
        "position": "absolute",
        "border": "none",
        "left": "8%",
        "background": "#99A9BF",
        "border-radius": "5px 0 0 5px",
        "width": "40px",
        "height": "30px",
        "color": "white",
        "font-size": "24px"
      },
      on: {
        "click": function($event) {
          _vm.min(index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "position": "absolute",
        "top": "-4px",
        "left": "15px"
      }
    }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
      staticClass: "shopping-product-number",
      staticStyle: {
        "position": "absolute",
        "left": "45%",
        "font-size": "19px"
      },
      attrs: {
        "width": "20"
      }
    }, [_vm._v(_vm._s(item.goods_num))]), _vm._v(" "), _c('button', {
      staticStyle: {
        "position": "absolute",
        "right": "10%",
        "background": "#99A9BF",
        "border-radius": "0 5px 5px 0",
        "border": "none",
        "width": "40px",
        "height": "30px",
        "color": "white",
        "font-size": "20px"
      },
      on: {
        "click": function($event) {
          _vm.max(index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "position": "absolute",
        "top": "-1px",
        "left": "12px"
      }
    }, [_vm._v("+")])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "25%",
        "text-align": "right"
      }
    }, [_c('div', {
      staticClass: "shopping-remove-product",
      on: {
        "click": function($event) {
          _vm.remove_order(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("./assets/store/icon-close.png"),
        "width": "20"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "shopping-product-price",
      staticStyle: {
        "font-size": "24px",
        "color": "#5E6D82",
        "margin-top": "15%"
      }
    }, [_vm._v("\n                                 $" + _vm._s(parseFloat(item.goods_price) * item.goods_num) + "\n                            ")])])])])
  })), _vm._v(" "), (_vm.goods.length == 0) ? _c('div', {
    staticClass: "empty-cart"
  }, [_c('img', {
    attrs: {
      "src": require("./assets/profile/empty-cart.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('shopping_card_null')))]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.goToShopping
    }
  }, [_vm._v(_vm._s(_vm.$t('shopping_card_go_to_shopping')))])]) : _vm._e(), _vm._v(" "), (_vm.goods.length > 0) ? _c('Row', {
    staticStyle: {
      "position": "absolute",
      "top": "80%",
      "right": "0%",
      "width": "100%",
      "background": "#f9fcff",
      "padding-right": "25px"
    }
  }, [_c('i-col', {
    staticStyle: {
      "margin": "20px auto",
      "text-align": "right"
    },
    attrs: {
      "span": 24,
      "width": "80%"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "24px",
      "color": "#5E6D82"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('shopping_card_total', {
    count: _vm.orderNumberTotal
  })) + " USD $" + _vm._s(_vm.orderTotal))]), _vm._v(" "), _c('button', {
    staticClass: "Product-shopping-btn",
    on: {
      "click": _vm.checkOut
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('check_out_btn')) + "\n                    ")])])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "body-content-container"
  }, [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "footer",
    staticStyle: {
      "margin-top": "3px"
    }
  }, [_c('div', {
    staticClass: "layout-copy"
  }, [_c('Row', {
    staticClass: "max_width"
  }, [_c('Col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 14
    }
  }, [_c('div', {
    staticClass: "layout-copy-main",
    attrs: {
      "id": "pc_footer"
    }
  }, [_c('Row', {
    staticClass: "footer-row"
  }, [_c('Col', {
    staticClass: "copy-g",
    attrs: {
      "xs": 8,
      "sm": 8,
      "md": 8,
      "lg": 8
    }
  }, [_c('div', {
    staticClass: "copy-header"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'FooterShop'
      }
    }
  }, [_c('p', {
    staticClass: "copy-title"
  }, [_vm._v(_vm._s(_vm.$t('footer_shop')))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'mogos',
        query: {
          id: 1
        }
      }
    }
  }, [_c('p', {
    staticClass: "copy-item"
  }, [_vm._v("MOGO S")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Go'
      }
    }
  }, [_c('p', {
    staticClass: "copy-item"
  }, [_vm._v("iGo")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Connect'
      }
    }
  }, [_c('p', {
    staticClass: "copy-item"
  }, [_vm._v("iConnect")])])], 1)]), _vm._v(" "), _c('Col', {
    staticClass: "copy-g",
    attrs: {
      "xs": 8,
      "sm": 8,
      "md": 8,
      "lg": 8
    }
  }, [_c('div', {
    staticClass: "copy-header"
  }, [_c('p', {
    staticClass: "copy-title"
  }, [_vm._v(_vm._s(_vm.$t('footer_about_ifree')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'AboutiFREE'
      }
    }
  }, [_c('p', {
    staticClass: "copy-item"
  }, [_vm._v(_vm._s(_vm.$t('footer_about_us')))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'information'
      }
    }
  }, [_c('p', {
    staticClass: "copy-item"
  }, [_vm._v(_vm._s(_vm.$t('footer_media')))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'ContactUs'
      }
    }
  }, [_c('p', {
    staticClass: "copy-item"
  }, [_vm._v(_vm._s(_vm.$t('footer_Regional')))])])], 1)]), _vm._v(" "), _c('Col', {
    staticClass: "copy-g",
    attrs: {
      "xs": 8,
      "sm": 8,
      "md": 8,
      "lg": 8
    }
  }, [_c('div', {
    staticClass: "copy-header"
  }, [_c('p', {
    staticClass: "copy-title"
  }, [_vm._v(_vm._s(_vm.$t('footer_support')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'HowTobuy'
      }
    }
  }, [_c('p', {
    staticClass: "copy-item"
  }, [_vm._v(_vm._s(_vm.$t('footer_howtoway')))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'PhysicalStore'
      }
    }
  }, [_c('p', {
    staticClass: "copy-item"
  }, [_vm._v(_vm._s(_vm.$t('footer_Resellers')))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Services'
      }
    }
  }, [_c('p', {
    staticClass: "copy-item"
  }, [_vm._v(_vm._s(_vm.$t('footer_FAQ')))])])], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mobile-footer"
  }, [_c('Collapse', {
    attrs: {
      "accordion": ""
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  }, [_c('Panel', {
    attrs: {
      "name": "1"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'FooterShop'
      }
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('footer_shop')) + "\n                            ")]), _vm._v(" "), _c('p', {
    staticClass: "copy-title",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'mogos',
        query: {
          id: 1
        }
      }
    }
  }, [_c('p', {
    staticClass: "copy-item"
  }, [_vm._v("MOGO S")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Go'
      }
    }
  }, [_c('p', {
    staticClass: "copy-item"
  }, [_vm._v("iGo")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Connect'
      }
    }
  }, [_c('p', {
    staticClass: "copy-item"
  }, [_vm._v("iConnect")])])], 1)], 1), _vm._v(" "), _c('Panel', {
    attrs: {
      "name": "2"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('footer_about_ifree')) + "\n                            "), _c('p', {
    staticClass: "copy-title",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'AboutiFREE'
      }
    }
  }, [_c('p', {
    staticClass: "copy-item"
  }, [_vm._v(_vm._s(_vm.$t('footer_about_us')))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'information'
      }
    }
  }, [_c('p', {
    staticClass: "copy-item"
  }, [_vm._v(_vm._s(_vm.$t('footer_media')))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'ContactUs'
      }
    }
  }, [_c('p', {
    staticClass: "copy-item"
  }, [_vm._v(_vm._s(_vm.$t('footer_Regional')))])])], 1)]), _vm._v(" "), _c('Panel', {
    attrs: {
      "name": "3"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('footer_support')) + "\n                            "), _c('p', {
    staticClass: "copy-title",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'HowTobuy'
      }
    }
  }, [_c('p', {
    staticClass: "copy-item"
  }, [_vm._v(_vm._s(_vm.$t('footer_howtoway')))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'PhysicalStore'
      }
    }
  }, [_c('p', {
    staticClass: "copy-item"
  }, [_vm._v(_vm._s(_vm.$t('footer_Resellers')))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Services'
      }
    }
  }, [_c('p', {
    staticClass: "copy-item"
  }, [_vm._v(_vm._s(_vm.$t('footer_FAQ')))])])], 1)])], 1)], 1)]), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 6,
      "lg": 10
    }
  }, [_c('Row', [_c('div', {
    staticClass: "qr-main"
  }, [_c('Col', {
    staticStyle: {
      "padding-top": "12%"
    },
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24
    }
  }, [_c('p', {
    staticClass: "copy-title"
  }, [_vm._v(_vm._s(_vm.$t('contact_us_mainpage_title')))]), _vm._v(" "), _c('div', {
    staticClass: "Social_group"
  }, [_vm._l((_vm.social), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "Social_icon"
    }, [_c('a', [_c('img', {
      attrs: {
        "src": item.img,
        "width": "38"
      },
      on: {
        "mouseout": function($event) {
          _vm.mousehide()
        },
        "click": function($event) {
          _vm.qrcodeShow(index)
        },
        "mouseover": function($event) {
          _vm.mouseShow(index)
        }
      }
    })])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.thisQR),
      expression: "thisQR"
    }],
    staticClass: "Social_qrcode"
  }, [(this.qrcode == 'iapp') ? _c('img', {
    attrs: {
      "src": require("./assets/iapp.png"),
      "width": "55%"
    }
  }) : (this.qrcode == 'wechat') ? _c('img', {
    attrs: {
      "src": require("./assets/wechat_qr.jpg"),
      "width": "60%"
    }
  }) : _vm._e(), _vm._v(" "), (this.qrcode == 'iapp') ? _c('p', [_vm._v("\n                                    " + _vm._s(_vm.$t('user_center_iapp_qrcode')) + "\n                                ")]) : (this.qrcode == 'wechat') ? _c('p', [_vm._v("\n                                    " + _vm._s(_vm.$t('contact_way2')) + "\n                                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mydiv"
    }
  })])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "layout-copy1",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "left",
      "margin": "5px 0"
    }
  }, [_vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/terms_of_law"
    }
  }, [_vm._v(_vm._s(_vm.$t('agree_terms_of_law')))]), _vm._v("  | "), _c('router-link', {
    staticStyle: {
      "padding": "0 2px"
    },
    attrs: {
      "to": {
        name: 'terms_of_service'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('agree_terms_of_conditions')))]), _vm._v(" | "), _c('router-link', {
    staticStyle: {
      "padding": "0 2px"
    },
    attrs: {
      "to": {
        name: 'privacy_policy'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('agree_privacy_policy')))]), _vm._v("\n                                | "), _c('router-link', {
    staticStyle: {
      "padding": "0 2px"
    },
    attrs: {
      "to": {
        name: 'sales_and_refund'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('return_policy')))])], 1), _vm._v("\n                            Copyright © 2018 iFREE GROUP Inc. All rights reserved.\n\n                        ")])], 1)])], 1)], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-728d8873","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 829
// module chunks = 0